'use strict';

module.exports = list;

function list(node) {
  var fn = node.ordered ? this.visitOrderedItems : this.visitUnorderedItems;
  return fn.call(this, node);
}